export interface ProcessedError {
  statusCode: number;
  errorMessage: string;
}
